module.exports = __webpack_public_path__ + "img/protoCovid.f30e31d0.jpg";